import { render, staticRenderFns } from "./GameButton.vue?vue&type=template&id=45975895&scoped=true&"
import script from "./GameButton.vue?vue&type=script&lang=js&"
export * from "./GameButton.vue?vue&type=script&lang=js&"
import style0 from "./GameButton.vue?vue&type=style&index=0&id=45975895&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45975895",
  null
  
)

export default component.exports